import moment from "moment";

export const getInsuranceAge = (effectiveDate: Date, dateOfBirth: Date): number => {
    const EffectiveDateModificated = moment(effectiveDate).add({
        days: 1,
        months: 6
    });

    let insuranceAge = EffectiveDateModificated.year() - moment(dateOfBirth).year();

    if (
        moment(dateOfBirth).month() > EffectiveDateModificated.month() ||
        (EffectiveDateModificated.year() == moment(dateOfBirth).year() && moment(dateOfBirth).day() < EffectiveDateModificated.day())
    ) {
        insuranceAge -= 1;
    }

    return insuranceAge;
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/helpers.ts